import { render, staticRenderFns } from "./packageDetails.vue?vue&type=template&id=108cf5e4&scoped=true"
import script from "./packageDetails.vue?vue&type=script&lang=js"
export * from "./packageDetails.vue?vue&type=script&lang=js"
import style0 from "./packageDetails.vue?vue&type=style&index=0&id=108cf5e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108cf5e4",
  null
  
)

export default component.exports